import Vue from 'vue';
import i18n from './commons/systemCommon/language.js';
window.i18n = i18n;
import App from './App.vue';

import './commons/systemCommon/importResources.js';
import router from './mainRouter';
import './commons/systemCommon/nprogress.js';
import cookies from 'js-cookie';
Vue.prototype.$mainVue = Vue;
Vue.config.productionTip = false;
window.vue = new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
//初始化window.vue对象后执行
require('./commons/loadConfig.js');
//加载登录程序
require('./commons/systemCommon/importLoginProcess.js');
//加载插件
require('./commons/systemCommon/importPlugins.js');
if (window.config.noRefresh) {
    require('./commons/systemCommon/noRefresh.js');
}
if (window.config.noRightClick) {
    require('./commons/systemCommon/noRightClick.js');
}
//触发退出登录事件
window.vue.$EventBus.$on('mainLogoutEvent', () => {
    window.vue.$socketApi.close(JSON.parse(sessionStorage.getItem('socketInfo')).agentId);
});
document.getElementsByTagName('body')[0].className = cookies.get(window.app.sPlatformFlg + 'tiandy_jp_skin') || window.mainSkin;
document.getElementsByTagName('html')[0].className = cookies.get('tiandy_jp_language') || window.app.defaultLanguage;
